import { CAROUSEL_TYPE, ACTIONS } from './constants';
import { ICarouselState, ICarouselAction } from './types';

export const carouselReducer = (state: ICarouselState, action: ICarouselAction) => {
  switch (action.type) {
    case ACTIONS.RESET: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case ACTIONS.SET_DIMENSIONS: {
      if (action.payload === undefined) {
        return state;
      }

      const {
        containerWidth,
        containerHeight,
        slidesInFrame,
        slidesToMove,
        slideWidth,
        slideHeight,
      } = action.payload;

      if (
        containerWidth === undefined ||
        containerHeight === undefined ||
        slidesInFrame === undefined ||
        slidesToMove === undefined ||
        slideWidth === undefined ||
        slideHeight === undefined
      ) {
        return state;
      }

      const { type, slideMargin, showNav, numberOfSlides, navPadding } = state;

      let maxSlidesInFrame = slidesInFrame;
      if (type === CAROUSEL_TYPE.HORIZONTAL) {
        maxSlidesInFrame = Math.ceil(containerWidth / slideWidth);
      } else {
        maxSlidesInFrame = Math.ceil(containerHeight / slideHeight);
      }

      let newSlidesInFrame = slidesInFrame;
      if (maxSlidesInFrame !== slidesInFrame && maxSlidesInFrame < slidesInFrame) {
        newSlidesInFrame = maxSlidesInFrame;
      }

      const canShowNav = showNav && newSlidesInFrame < numberOfSlides;

      let newSlideMargin = slideMargin;
      if (newSlidesInFrame > 1) {
        const extraSpace =
          type === CAROUSEL_TYPE.HORIZONTAL
            ? containerWidth - navPadding * 2 - slidesInFrame * slideWidth
            : containerHeight - navPadding * 2 - slidesInFrame * slideHeight;
        newSlideMargin = extraSpace / (slidesInFrame - 1);
      } else {
        newSlideMargin = 0;
      }

      return {
        ...state,
        containerWidth,
        slidesToMove,
        slideWidth,
        slideHeight,
        canShowNav,
        slideMargin: newSlideMargin,
        slidesInFrame: newSlidesInFrame,
      };
    }

    case ACTIONS.SET_SLIDE: {
      if (action.payload === undefined) {
        return state;
      }

      const { slideIndex } = action.payload;
      const { slidesInFrame, numberOfSlides } = state;

      if (slideIndex === undefined) {
        return state;
      }

      if (slideIndex < 0 || slideIndex > numberOfSlides - 1) {
        return state;
      }

      let newIndex = slideIndex;
      if (newIndex + slidesInFrame > numberOfSlides - 1) {
        newIndex = numberOfSlides - slidesInFrame;
      }

      return {
        ...state,
        realSlideIndex: slideIndex,
        slideIndex: newIndex,
      };
    }

    case ACTIONS.SLIDE_NEXT: {
      const { slidesToMove, numberOfSlides, slidesInFrame, slideIndex } = state;

      let newIndex = slideIndex + slidesToMove;
      let newRealSlideIndex = newIndex;

      if (newIndex + slidesInFrame > numberOfSlides - 1) {
        newIndex = numberOfSlides - slidesInFrame;
      }

      if (newRealSlideIndex > numberOfSlides - 1) {
        newRealSlideIndex = numberOfSlides - 1;
      }

      return {
        ...state,
        realSlideIndex: newRealSlideIndex,
        slideIndex: newIndex,
      };
    }

    case ACTIONS.SLIDE_PREV: {
      const { slideIndex, slidesToMove, slidesInFrame, numberOfSlides } = state;
      let newIndex = slideIndex - slidesToMove;

      if (newIndex < 0) {
        newIndex = 0;
      }

      if (newIndex + slidesInFrame > numberOfSlides - 1) {
        newIndex = numberOfSlides - slidesInFrame;
      }

      return {
        ...state,
        realSlideIndex: newIndex,
        slideIndex: newIndex,
      };
    }

    case ACTIONS.SET_POS: {
      if (action.payload === undefined) {
        return state;
      }

      const { posX, posY } = action.payload;

      if (posX === undefined || posY === undefined) {
        return state;
      }

      return {
        ...state,
        posX,
        posY,
      };
    }

    case ACTIONS.SET_NUMBER_SLIDES: {
      const { numberOfSlides } = action.payload;
      return {
        ...state,
        numberOfSlides,
      };
    }
  }
};
